;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface LoadingSpinnerProps extends React.ComponentProps<"div"> {
	innerSpinner?: React.ComponentProps<"div">;
	loadingLabel?: ReactNode;
}

export function LoadingSpinner({
	className,
	innerSpinner = {},
	loadingLabel,
	children = null,
	...props
}: LoadingSpinnerProps) {
	return (
		<div
			{...props}
			className={cn(
				"flex items-center justify-center",
				loadingLabel && "flex-col gap-2 text-muted-foreground text-sm",
				className,
			)}
			data-slot="spinner-wrapper"
		>
			<div
				{...innerSpinner}
				className={cn(
					"size-8 animate-spin animation-duration-[400ms] rounded-full border-2 border-t-primary/20! border-primary",
					innerSpinner?.className ?? "",
				)}
				data-slot="spinner"
			/>
			<span data-slot="loading-label">
				{loadingLabel ? loadingLabel : null}
			</span>
			{children}
		</div>
	);
}
